import Vue from 'vue';
import VueRouter from 'vue-router';
import MainPage from '../components/MainPage.vue';
import OrderCreate from '../components/OrderCreate.vue';
import UserLogin from '@/components/Login.vue';
import OrderForm from '../components/OrderForm.vue';
import OrderEdit from '../components/OrderEdit.vue';
import AllTask from '@/components/AllTask.vue';
import ChatTabs from '@/components/ChatTabs.vue';
import CalendarComponent from '@/components/CalendarComponent.vue';
import TaskSto from '@/components/TaskSto.vue';
import InfoBonus from '@/components/InfoBonus.vue';
import BonusAll from '@/components/BonusAll.vue';
import ManagerRating from '@/components/ManagerRating.vue';
import UserSettings from '@/components/UserSettings';
import Communications from '@/components/Communications.vue';
import store from '@/store/store'; 
import ManagerRatingDetails from '@/components/ManagerRatingDetails.vue';
import PodborTree from '@/components/PodborTree.vue';
import StatusMatrix from '@/components/StatusMatrix.vue';
import ReviewResponse from '@/components/ReviewResponse.vue';
import RetailCrmMoyskladReport from '@/components/RetailCrmMoyskladReport.vue';
import ManagersStatusPage from '@/components/ManagersStatusPage.vue';
import AllUsersActivityPage from '@/components/AllUsersActivityPage.vue';
import BotDialogAnalytics from '@/components/BotDialogAnalytics.vue';
import KassaAfterRedirect from '@/components/KassaAfterRedirect.vue';
import Kassa30DaysPage from '@/components/Kassa30DaysPage.vue';
import KarvataDovozPage from '@/components/KarvataDovozPage.vue';

import TimeSellers from '@/components/TimeSellers.vue';

Vue.use(VueRouter);

// Храним историю маршрутов
let routeHistory = [];

const routes = [
  {
    path: '/',
    name: 'MainPage',
    component: MainPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/podbor-tree',
    name: 'PodborTree',
    component: PodborTree,
    meta: { requiresAuth: true },
  },
  {
    path: '/ordercreate',
    name: 'OrderCreate',
    component: OrderCreate,
    meta: { requiresAuth: true },
  },
  {
    path: '/alltask',
    name: 'AllTask',
    component: AllTask,
    meta: { requiresAuth: true },
  },
  {
    path: '/communications',
    name: 'Communications',
    component: Communications,
    meta: { requiresAuth: true },
  },
  {
    path: '/orders',
    name: 'OrderForm',
    component: OrderForm,
    meta: { requiresAuth: true },
  },
  {
    path: '/chats',
    name: 'ChatTabs',
    component: ChatTabs,
    meta: { requiresAuth: true },
  },
  {
    path: '/sto',
    name: 'CalendarComponent',
    component: CalendarComponent,
    meta: { requiresAuth: true },
  },
  {
    path: '/info_bonus',
    name: 'InfoBonus',
    component: InfoBonus,
    meta: { requiresAuth: true },
  },
  {
    path: '/timesellers',
    name: 'TimeSellers',
    component: TimeSellers,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: UserLogin,
    meta: { guest: true },
  },
  {
    path: '/bonus',
    name: 'BonusAll',
    component: BonusAll,
    meta: { requiresAuth: true },
  },  
  {
    path: '/tasksto',
    name: 'TaskSto',
    component: TaskSto,
    meta: { requiresAuth: true },
  },
   {
    path: '/setting',
    name: 'UserSettings',
    component: UserSettings,
    meta: { requiresAuth: true },
  },
  {
    path: '/status-matrix',
    name: 'StatusMatrix',
    component: StatusMatrix,
    meta: { requiresAuth: true },
  },
  {
    path: '/reviews-response',
    name: 'ReviewResponse',
    component: ReviewResponse,
    meta: { requiresAuth: true },
  },
  {
    path: '/rating',
    name: 'ManagerRating',
    component: ManagerRating,
    meta: { requiresAuth: true },
  },
  {
    path: '/retailcrm-moysklad-report',
    name: 'RetailCrmMoyskladReport',
    component: RetailCrmMoyskladReport,
    meta: { requiresAuth: true, requiresRukovodstvo: true },
  },
  {
    path: '/kassa-after-redirect',
    name: 'KassaAfterRedirect',
    component: KassaAfterRedirect,
    meta: { requiresAuth: true, requiresRukovodstvo: true },
  },
  {
    path: '/kassa-30-days',
    name: 'Kassa30Days',
    component: Kassa30DaysPage,
    meta: { requiresAuth: true, requiresRukovodstvo: true },
  },
  {
    path: '/karvata-dovoz',
    name: 'KarvataDovoz',
    component: KarvataDovozPage,
    // Доступ по прямой ссылке без проверки роли/логина в router
  },
  {
    path: '/team-status',
    name: 'ManagersStatus',
    component: ManagersStatusPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/users-activity',
    name: 'AllUsersActivity',
    component: AllUsersActivityPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/bot-dialog-analytics',
    name: 'BotDialogAnalytics',
    component: BotDialogAnalytics,
    meta: { requiresAuth: true },
  },
  {
    path: '/manager-rating/:managerId',
    name: 'ManagerRatingDetails',
    component: ManagerRatingDetails,
    meta: { requiresAuth: true },
  },
  {
    path: '/order',
    redirect: '/orders',
  },
  {
    path: '/order/:orderId',
    redirect: to => ({ path: `/edit/${to.params.orderId}` }),
  },
  {
    path: '/edit/:orderId',
    name: 'OrderEdit',
    component: OrderEdit,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }; // Всегда прокручивать к началу
  },
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user');

  // Проверка авторизации
  if (to.matched.some(record => record.meta.guest) && loggedIn) {
    next('/'); // Перенаправляем авторизованного пользователя с гостевых страниц
    return;
  }
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/login'); // Перенаправляем неавторизованного пользователя
    return;
  }
  if (to.matched.some(record => record.meta.requiresRukovodstvo)) {
    let user = null;
    try {
      user = loggedIn ? JSON.parse(loggedIn) : null;
    } catch (e) {
      user = null;
    }
    const role = user && String(user.role || '').toLowerCase();
    if (!role || !role.includes('руководство')) {
      next('/');
      return;
    }
  }
  next(); // Разрешаем переход

  // Проверяем кнопку "Назад"
  const isBackNavigation = routeHistory.length > 1 && routeHistory[routeHistory.length - 2] === to.path;
  if (isBackNavigation) {
    console.log('Кнопка "Назад" нажата');
    //store.dispatch('savedFormsModule/clearSavedForms');
    store.commit('clearProducts')
   
    if (to.name === 'OrderForm') {
       //store.dispatch('savedFormsModule/clearSavedForms');
      store.commit('clearProducts');
      console.log('Назад на страницу OrderForm');
    }
  }

  // Обновляем историю маршрутов
  if (!routeHistory.includes(to.path)) {
    routeHistory.push(to.path);
  } else {
    routeHistory.pop(); // Если возвращаемся назад, удаляем маршрут из истории
  }
});

export default router;

